<template>
  <section id="conversation">
    <b-breadcrumb
      :items="breadcrumb"
    />

    <b-row>
      <b-col cols="12">
        <b-card-actions
          ref="cardActions"
          title="Instagram Vagas"
          class="form-filters"
          :action-close="false"
          :action-refresh="true"
          :action-collapse="false"
          @refresh="getJobs"
        >
          <b-row>
            <b-col cols="12">
              <h4 class="mb-2">
                Filtrar por Status
              </h4>

              <div class="d-flex flex-row">
                <b-form-checkbox
                  :checked="filtersValues.status.copied"
                  class="mr-2"
                  @change="(e) => filterStatus(e, 'copied')"
                >
                  Copiado
                </b-form-checkbox>

                <b-form-checkbox
                  :checked="filtersValues.status.ready"
                  class="mr-2"
                  @change="(e) => filterStatus(e, 'ready')"
                >
                  Pronto
                </b-form-checkbox>

                <b-form-checkbox
                  :checked="filtersValues.status.discarded"
                  class="mr-2"
                  @change="(e) => filterStatus(e, 'discarded')"
                >
                  Descartado
                </b-form-checkbox>

                <b-form-checkbox
                  :checked="filtersValues.status.created"
                  class="mr-2"
                  @change="(e) => filterStatus(e, 'created')"
                >
                  Vaga criada
                </b-form-checkbox>

                <b-form-checkbox
                  :checked="filtersValues.status.removed"
                  class="mr-2"
                  @change="(e) => filterStatus(e, 'removed')"
                >
                  Vaga removida
                </b-form-checkbox>
              </div>

              <b-button
                id="btn-processar"
                class="mt-3"
                variant="primary"
                @click="getJobs"
              >
                Buscar
              </b-button>
            </b-col>
          </b-row>
        </b-card-actions>

        <b-card>
          <b-row>
            <b-col cols="6">
              <p>Mostrando {{ pages.from }} até {{ pages.to }} de {{ pages.total }} resultados</p>
            </b-col>

            <b-col cols="6">
              <!-- pagination nav -->
              <b-pagination-nav
                v-model="currentPage"
                :number-of-pages="pages.last_page"
                :link-gen="() => { return '#' }"
                align="end"
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-table
                :busy="isLoading"
                responsive
                :items="results"
                :fields="result_fields"
                show-empty
                sort-icon-left
                no-local-sorting
                :sort-by.sync="filtersValues.sortBy"
                :sort-desc.sync="filtersValues.sortDesc"
                @sort-changed="sortingChanged"
              >
                <template #empty>
                  <h4 class="text-center mt-2 mb-2">
                    Nenhum resultado encontrado
                  </h4>
                </template>

                <template #head(selected)>
                  <div class="text-nowrap">
                    <b-form-checkbox
                      :checked="false"
                      @change="toggleAll"
                    />
                  </div>
                </template>

                <template #cell(selected)="row">
                  <div
                    class="id-select"
                    @click.prevent="onClickSelect(row.item)"
                  >
                    <b-form-checkbox
                      v-model="row.item.selected"
                      :disabled="isSubmitting"
                    />
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center table-spinner">
                    <b-spinner label="Loading..." />
                    <strong>Carregando...</strong>
                  </div>
                </template>

                <template #cell(status)="row">
                  <b-form-group
                    label=""
                    label-for="type"
                  >
                    <b-form-select
                      id="type"
                      :options="statusOptions"
                      :disabled="isLoadingStatus"
                      :value="row.item.status"
                      @change="(e) => changeStatus(row.item.id, e)"
                    />
                  </b-form-group>
                </template>

                <template #cell(media_image)="row">
                  <a
                    :href="row.item.media_image_link"
                    target="_blank"
                  ><img
                    alt=""
                    :src="row.item.media_image_link"
                    width="80"
                  /></a>
                </template>

                <template #cell(title)="row">
                  <div class="d-flex align-items-center">
                    <p>
                      <span><strong>Título:</strong> {{ row.item.title }}</span> <br />
                      <span><strong>Empresa:</strong> {{ row.item.company }}</span> <br />
                      <span><strong>Região:</strong> {{ row.item.region }}</span><br />
                      <span><strong>Data da cópia:</strong> {{ formatDateTimeDbToView(row.item.created_at) }}</span>
                    </p>
                  </div>
                </template>

                <template #cell(actions)="row">
                  <div class="d-flex flex-column align-items-center">
                    <b-button
                      variant="outline-primary"
                      title="Abrir vaga original"
                      class="mt-1"
                      size="sm"
                      @click="openLink(row.item.link)"
                    >
                      Abrir vaga <feather-icon icon="ExternalLinkIcon" />
                    </b-button>

                    <b-button
                      variant="outline-primary"
                      title="Copiar url da vaga original"
                      class="mt-1"
                      size="sm"
                      @click="sendToClipboard(row.item.link)"
                    >
                      Copiar url <feather-icon icon="CopyIcon" />
                    </b-button>

                    <b-button
                      v-if="!row.item.media_image"
                      variant="outline-primary"
                      title="Gerar imagem"
                      class="mt-1"
                      size="sm"
                      @click="generateImage(row.item.id)"
                    >
                      Gerar imagem
                    </b-button>

                    <b-button
                      v-if="row.item.status !== 'created' && row.item.media_image !== null"
                      variant="outline-primary"
                      title="Publicar no instagram"
                      class="mt-1"
                      size="sm"
                      @click="postOnInstagram(row.item.id)"
                    >
                      Publicar no instagram
                    </b-button>
                  </div>
                </template>

                <template #cell(view)="row">
                  <div class="text-nowrap text-center">
                    <b-button
                      variant="flat-primary"
                      title="Editar"
                      @click="showJob(row.item)"
                    >
                      <feather-icon
                        icon="EyeIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </b-button>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>

          <div class="text-right mb-4">
            <b-button
              variant="primary"
              class="mr-1"
              :disabled="isSubmitting || selectedUsers.length === 0"
              @click="handleProcessChosen"
            >
              <b-spinner
                v-if="isSubmitting"
                small
              />
              Gerar imagem dos selecionados
            </b-button>
          </div>

          <b-row>
            <b-col cols="6">
              <p>Mostrando {{ pages.from }} até {{ pages.to }} de {{ pages.total }} resultados</p>
            </b-col>

            <b-col cols="6">
              <!-- pagination nav -->
              <b-pagination-nav
                v-model="currentPage"
                :number-of-pages="pages.last_page"
                :link-gen="() => { return '#' }"
                align="end"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      ref="job-detail-modal"
      hide-footer
      size="lg"
      title="Detalhes da Vaga"
    >
      <div>
        <strong>Resultado prompt 3</strong>
        <br />
        <br />
        <!-- eslint-disable vue/no-v-html -->
        <p
          v-if="selectedItem && selectedItem.media_caption"
          v-html="selectedItem.media_caption.split('\n').join('<br />')"
        >
        </p>
      </div>

    </b-modal></section>
</template>

<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import UserService from '@/services/userService'
import toast from '@/mixins/toast'
import swall from '@/mixins/swall'
import { formatDateTimeDbToView } from '@/utils/helpers'
import sendToClipboard from '@/mixins/sendToClipboard'

import {
  BRow,
  BCol,
  BTable,
  BPaginationNav,
  BSpinner,
  BButton,
  BBreadcrumb,
  BFormGroup,
  BFormSelect,
  BFormCheckbox,
  BCard,
} from 'bootstrap-vue'
import JobVacancyService from '@/services/jobVacancyService'

export default {
  components: {
    BCard,
    BFormCheckbox,
    BFormSelect,
    BFormGroup,
    BCardActions,
    BRow,
    BCol,
    BTable,
    BPaginationNav,
    BSpinner,
    BButton,
    BBreadcrumb,
  },
  mixins: [toast, swall, sendToClipboard],
  data() {
    return {
      userService: null,
      isLoading: false,
      isLoadingStatus: false,
      isSubmitting: false,
      cardData: {},
      selectedItem: null,
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'cms-dashboard' },
        },
        {
          text: 'Ferramentas - Vagas',
          active: true,
        },
      ],

      filtersInitialValues: {},
      filtersValues: {
        status: {
          copied: true,
          ready: true,
          discarded: false,
          created: false,
          removed: true,
        },
        type: 'all',
        sortBy: 'id',
        sortDesc: true,
      },

      statusOptions: [
        {
          value: 'copied',
          text: 'Copiado do site de vagas',
        },
        {
          value: 'ready',
          text: 'Vaga pronta (todas IA já rodaram)',
        },
        {
          value: 'discarded',
          text: 'Descartado',
        },
        {
          value: 'created',
          text: 'Vaga publicada',
        },
        {
          value: 'removed',
          text: 'Vaga removida',
        },
      ],

      pages: 1,
      currentPage: 1,
      results: [],
      result_fields: [],
      formatDateTimeDbToView,
      preventCloseModal: false,
      dataAssignKanban: null,
      dataKanbanAdditional: null,
    }
  },
  computed: {
    variant() {
      return document.body.classList.contains('dark-layout') ? 'dark' : undefined
    },

    selectedUsers() {
      return this.results.filter(f => f.selected).map(m => (m.id))
    },
  },

  watch: {
    currentPage() {
      this.getJobs()
    },
  },

  created() {
    this.userService = new UserService()
    this.filtersInitialValues = { ...this.filtersValues }

    this.result_fields = [
      { key: 'selected', sortable: false, thStyle: 'width: 20px', tdClass: 'no-padding' },
      { key: 'id', label: 'ID', sortable: true },
      { key: 'origin', label: 'Origem', sortable: true },
      { key: 'status', label: 'Status', sortable: true },
      { key: 'title', label: 'Título, Região e Data', sortable: true },
      { key: 'actions', label: 'Ações', sortable: false },
      { key: 'media_image', label: 'Imagem', sortable: false },
      { key: 'view', label: 'Ver', sortable: false, thStyle: 'width: 180px' },
    ]

    this.getJobs()
  },

  methods: {
    handleProcessChosen() {
      const total = this.selectedUsers.length
      this.$swal({
        title: `Processar ${total} registros selecionados?`,
        text: 'Esta ação pode demorar alguns minutos',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, processar!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.isSubmitting = true
          JobVacancyService.generateImages(this.selectedUsers).then(() => {
            this.toastSuccess('Imagem gerada!')
            this.getJobs()
          }).catch(() => {
            this.swallError('Erro ao executar!', 'Não foi possível executar todos os prompts', 'Ok')
          }).finally(() => {
            this.isSubmitting = false
          })
        }
      })
    },

    toggleAll(e) {
      this.results = this.results.map(m => ({
        ...m,
        selected: e,
      }))
    },

    filterStatus(e, status) {
      this.filtersValues.status[status] = e
    },

    onClickSelect(item) {
      if (!this.isSubmitting) {
        // eslint-disable-next-line no-param-reassign
        item.selected = !item.selected
      }
    },

    handleCtrlEnter(e) {
      if (e.ctrlKey) {
        this.getJobs()
      }
    },

    openLink(link) {
      window.open(link, '_blank')
    },

    generateImage(id) {
      this.isLoading = true
      JobVacancyService.generateImage(id).then(() => {
        this.toastSuccess('Imagem gerada!')
        this.getJobs()
      }).catch(() => {
        this.swallError('Erro ao executar!', 'Não foi possível executar os prompts', 'Ok')
      }).finally(() => {
        this.isLoading = false
      })
    },

    postOnInstagram(id) {
      this.isLoading = true
      JobVacancyService.postOnInstagram(id).then(response => {
        if (response.data.data.media_id !== null) {
          this.toastSuccess('Vaga publicada!')
        } else {
          this.toastDanger('Erro ao publicar a vaga!')
        }
        this.getJobs()
      }).catch(() => {
        this.swallError('Erro ao executar!', 'Não foi possível executar os prompts', 'Ok')
      }).finally(() => {
        this.isLoading = false
      })
    },

    changeStatus(id, newStatus) {
      this.isLoadingStatus = true
      this.results = this.results.map(m => ({
        ...m,
        status: m.id === id ? newStatus : m.status,
      }))
      JobVacancyService.changeStatus(id, newStatus).then(() => {
        if (['discarded', 'created'].includes(newStatus)) {
          this.results = this.results.filter(f => f.id !== id)
        }
        this.toastSuccess('Status alterado!')
      }).finally(() => {
        this.isLoadingStatus = false
      })
    },

    showJob(item) {
      this.$refs['job-detail-modal'].show()
      this.selectedItem = item
    },

    getJobs() {
      this.isLoading = true
      this.filtersValues.page = this.currentPage

      const filters = Object.fromEntries(Object.entries(this.filtersValues))
      filters.status = Object.entries(filters.status).filter(f => f[1]).map(m => m[0])

      JobVacancyService.list(filters).then(response => {
        this.results = response.data.data.job_vacancies.data.map(m => ({
          ...m,
          selected: false,
        }))
        this.pages = {
          ...response.data.data.job_vacancies,
          data: null,
        }
      }).finally(() => {
        this.isLoading = false
        this.$refs.cardActions.showLoading = false
      })
    },

    reset() {
      this.filtersValues = JSON.parse(JSON.stringify(this.filtersInitialValues))
      this.results = []
    },

    sortingChanged(ctx) {
      this.filtersValues.sortBy = ctx.sortBy
      this.filtersValues.sortDesc = ctx.sortDesc
      this.getJobs()
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .header-card{
    margin-bottom: 20px;
  }

  .form-buttons button{
    margin-right: 10px;
  }
</style>
